webpackJsonp([263791100135453],{

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMarkdown = __webpack_require__(47);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _core = __webpack_require__(22);
	
	var _Page = __webpack_require__(71);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PaperContainer = __webpack_require__(72);
	
	var _PaperContainer2 = _interopRequireDefault(_PaperContainer);
	
	var _styled = __webpack_require__(24);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Section = __webpack_require__(38);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _iStock_000037546596_Large = __webpack_require__(808);
	
	var _iStock_000037546596_Large2 = _interopRequireDefault(_iStock_000037546596_Large);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var content = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Commitment' },
	    'We offer a free, no obligation in-home consultation to thoroughly assess your individual care needs and recommend appropriate home care services.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Confidence' },
	    'Our home care services and the respective costs are clearly spelled out in your Service Agreement \u2014 not a long term contract.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Quality' },
	    'Your Caregiver will have undergone our highly personalized screening system, including interviews, thorough background check, training and follow-up.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Choice' },
	    'You will have the opportunity to interview any Caregiver we refer to you for your home care.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Comfort' },
	    'We promise to find you a Caregiver you trust - a dedicated person who makes you feel completely comfortable.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Satisfaction' },
	    'We perform announced and unannounced home visits and telephone follow-ups to ensure your continued home care satisfaction.'
	  )
	);
	
	var About = function About(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, xs: 12, sm: 8 },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'About - Home Care Plus' }),
	      _react2.default.createElement(
	        _Page2.default,
	        {
	          image: _iStock_000037546596_Large2.default,
	          title: "About"
	        },
	        content
	      )
	    )
	  );
	};
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iStock_000037546596_Large.319b0539.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-7ee2ea54684f95cfa415.js